const MAIL_KEYS = {
  ERROR: 'error',
  EMAIL: 'emailid',
  EMAIL_BODY: 'emailtext',
};

export { MAIL_KEYS };
